import { getInitialNodes } from '@/flow/config/fixedNodes';
import { getCurrentFlowLayoutPreset } from '@/flow/config/layoutPreset';
import { getDefaultData } from '@/flow/nodeRegistry';
import type { AppNode } from '@/flow/types';
import type { LearningFlow, LearningProblem } from './learningTypes';

export const normalizeLearningFlow = (flow: LearningFlow): LearningFlow => ({
  nodes: flow.nodes.map((node) => (
    node.id === 'start' && node.position.x < 40
      ? { ...node, position: { ...node.position, x: 40 } }
      : node
  )) as AppNode[],
  edges: flow.edges,
});

export const createInitialLearningFlow = (problem: LearningProblem): LearningFlow => {
  const preset = getCurrentFlowLayoutPreset();
  const fixedNodes = normalizeLearningFlow({
    nodes: getInitialNodes(preset) as AppNode[],
    edges: [],
  }).nodes;
  const start = fixedNodes.find(({ id }) => id === 'start');
  const end = fixedNodes.find(({ id }) => id === 'end');
  const cardCount = problem.initialCards.length;
  const columnCount = Math.min(preset === 'mobile' ? 2 : 3, cardCount);
  const rowCount = Math.ceil(cardCount / columnCount);
  const horizontalPadding = preset === 'mobile' ? 160 : preset === 'tablet' ? 180 : 190;
  const minX = (start?.position.x ?? 40) + horizontalPadding;
  const maxX = Math.max(minX, (end?.position.x ?? 790) - horizontalPadding);
  const centerY = start?.position.y ?? 150;
  const suppliedNodes = problem.initialCards.map(({ nodeKind, data }, index) => ({
    id: `${problem.id}-${nodeKind}-${index + 1}`,
    type: nodeKind,
    position: {
      x: columnCount === 1
        ? (minX + maxX) / 2
        : minX + (index % columnCount) * ((maxX - minX) / (columnCount - 1)),
      y: centerY + (Math.floor(index / columnCount) - (rowCount - 1) / 2) * 180,
    },
    data: { ...getDefaultData(nodeKind), ...data },
  } as AppNode));
  return { nodes: [...fixedNodes, ...suppliedNodes], edges: [] };
};